export const FETCH_TEAM_MEMBERS = '@@fetch_team_members';
export const FETCH_TEAM_MEMBERS_SUCCESS = '@@fetch_team_members_success';
export const FETCH_TEAM_MEMBERS_FAILURE = '@@fetch_team_members_failure';

export const DELETE_TEAM_MEMBER = '@@delete_team_member';
export const DELETE_TEAM_MEMBER_SUCCESS = '@@delete_team_member_success';
export const DELETE_TEAM_MEMBER_FAILURE = '@@delete_team_member_failure';

export const ADD_TEAM_MEMBER = '@@add_team_member';
export const ADD_TEAM_MEMBER_SUCCESS = '@@add_team_member_success';
export const ADD_TEAM_MEMBER_FAILURE = '@@add_team_member_failure';

export const UPDATE_TEAM_MEMBER = '@@update_team_member';
export const UPDATE_TEAM_MEMBER_SUCCESS = '@@update_team_member_success';
export const UPDATE_TEAM_MEMBER_FAILURE = '@@update_team_member_failure';

export const FETCH_PROJECT_ROLES = '@@fetch_project_roles';
export const FETCH_PROJECT_ROLES_SUCCESS = '@@fetch_project_roles_success';
export const FETCH_PROJECT_ROLES_FAILURE = '@@fetch_project_roles_failure';

export const FETCH_CERTIFICATIONS = '@@fetch_certifications';
export const FETCH_CERTIFICATIONS_SUCCESS = '@@fetch_certifications_success';
export const FETCH_CERTIFICATIONS_FAILURE = '@@fetch_certifications_failure';

export const FETCH_USERS = '@@fetch_users';
export const FETCH_USERS_SUCCESS = '@@fetch_users_success';
export const FETCH_USERS_FAILURE = '@@fetch_users_failure';

export const GET_PRESIGNED_URL = '@@get_presigned_url';
export const GET_PRESIGNED_URL_SUCCESS = '@@get_presigned_url_success';
export const GET_PRESIGNED_URL_FAILURE = '@@get_presigned_url_failure';

export const UPLOAD_CERTIFICATE = '@@upload_certificate';
export const UPLOAD_CERTIFICATE_SUCCESS = '@@upload_certificate_success';
export const UPLOAD_CERTIFICATE_FAILURE = '@@upload_certificate_failure';

export const CREATE_UPDATE_TEAM_MEMBER = '@@create_update_team_member';
export const CREATE_UPDATE_TEAM_MEMBER_SUCCESS = '@@create_update_team_member_success';
export const CREATE_UPDATE_TEAM_MEMBER_FAILURE = '@@create_update_team_member_failure';

export const DELETE_TEAM_MEMBER_CERT = '@@delete_team_member_cert';
export const DELETE_TEAM_MEMBER_CERT_SUCCESS = '@@delete_team_member_cert_success';
export const DELETE_TEAM_MEMBER_CERT_FAILURE = '@@delete_team_member_cert_failure';

export const CREATE_UPDATE_PROJECT_LEVEL_ROLES = '@@create_update_project_level_roles';
export const CREATE_UPDATE_PROJECT_LEVEL_ROLES_SUCCESS = '@@create_update_project_level_roles_success';
export const CREATE_UPDATE_PROJECT_LEVEL_ROLES_FAILURE = '@@create_update_project_level_roles_failure';

export const DELETE_PROJECT_LEVEL_ROLE = '@@delete_project_level_role';
export const DELETE_PROJECT_LEVEL_ROLE_SUCCESS = '@@delete_project_level_role_success';
export const DELETE_PROJECT_LEVEL_ROLE_FAILURE = '@@delete_project_level_role_failure'; 